exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flames-container{transition:1s;opacity:0}.flames-container.flames-shown{opacity:1}#panel{position:fixed;width:100vw;bottom:0;left:0;right:0;height:1000px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-adfd4298","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Flames.vue
// module id = 20
// module chunks = 0